import React, { Component } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Check } from "lucide-react";
import { MoneyTransferRequestDetails, WithdrawToAnyIBANMoneyTransferRequestDetails } from "../../models/MoneyTransferModal";
import { utils } from "../../utils/utils";
import { Col, Label, Row } from "reactstrap";
import { AppCard } from "../../components/ui";

interface WithdrawConfirmDialogueProps {
    withdrawToIBANDetails: WithdrawToAnyIBANMoneyTransferRequestDetails;
    isSubmitting: boolean;
    onSubmit: () => void;
    onHide: () => void;
}

class WithdrawConfirmDialogue extends Component<WithdrawConfirmDialogueProps> {
    render() {
        const { withdrawToIBANDetails, isSubmitting, onHide, onSubmit } = this.props;

        return (
            <Dialog
                header={"Withdraw Confirm Payment"}
                visible={!!withdrawToIBANDetails}
                style={{ width: "60vw" }}
                onHide={onHide}
                modal
                blockScroll
                draggable={false}
                resizable={false}
            >
                <AppCard className="m-0">
                    <AppCard.Body>
                        <div className="p-fluid">
                            <Row className="mb-1">
                                <Col md={"4"}>
                                    <Label>Source Name:</Label>
                                </Col>
                                <Col md={"8"}>
                                    <div>{withdrawToIBANDetails.sourceCustomerName}</div>
                                </Col>
                            </Row>

                            <Row className="mb-1">
                                <Col md={"4"}>
                                    <Label>Source Account:</Label>
                                </Col>
                                <Col md={"8"}>
                                    <div>
                                        {withdrawToIBANDetails.sourceCustomerAccount}{" "}
                                        <p className="text-success d-inline"> ({withdrawToIBANDetails.sourceCustomerCurrency})</p>
                                    </div>
                                </Col>
                            </Row>

                            <Row className="mb-1">
                                <Col md={"4"}>
                                    <Label>Balance:</Label>
                                </Col>
                                <Col md={"8"}>
                                    <div className="text-success d-inline">
                                        {utils.formatBalance(
                                            withdrawToIBANDetails.sourceCurrentBalance,
                                            withdrawToIBANDetails.sourceCustomerCurrency,
                                        )}
                                    </div>
                                </Col>
                            </Row>

                            <Row className="mb-1">
                                <Col md={"4"}>
                                    <Label>Beneficiary Name:</Label>
                                </Col>
                                <Col md={"8"}>
                                    <div>{withdrawToIBANDetails.beneficiaryCustomerName}</div>
                                </Col>
                            </Row>

                            <Row className="mb-1">
                                <Col md={"4"}>
                                    <Label>Beneficiary Account:</Label>
                                </Col>
                                <Col md={"8"}>
                                    <div>
                                        {withdrawToIBANDetails.beneficiaryCustomerAccount}{" "}
                                        <p className="text-success d-inline"> ({withdrawToIBANDetails.beneficiaryCustomerCurrency})</p>
                                    </div>
                                </Col>
                            </Row>

                            <Row className="mb-1">
                                <Col md={"4"}>
                                    <Label>Beneficiary Bank:</Label>
                                </Col>
                                <Col md={"8"}>
                                    <div>{withdrawToIBANDetails.beneficiaryCustomerBankName}</div>
                                </Col>
                            </Row>

                            <Row className="mb-1">
                                <Col md={"4"}>
                                    <Label>Amount:</Label>
                                </Col>
                                <Col>
                                    <div className="text-success d-inline">
                                        {utils.formatBalance(withdrawToIBANDetails.transactionAmount, withdrawToIBANDetails.sourceCustomerCurrency)}
                                    </div>
                                </Col>
                            </Row>

                            <Row className="mb-1">
                                <Col md={"4"}>
                                    <Label>Transaction Fee:</Label>
                                </Col>
                                <Col md={"8"}>
                                    <div className="text-success d-inline">
                                        {utils.formatBalance(withdrawToIBANDetails.transactionFee, withdrawToIBANDetails.sourceCustomerCurrency)}
                                    </div>
                                </Col>
                            </Row>

                            <Row className="mb-1">
                                <Col md={"4"}>
                                    <Label>Payment Notes:</Label>
                                </Col>
                                <Col md={"8"}>
                                    <div>{withdrawToIBANDetails.paymentNotes}</div>
                                </Col>
                            </Row>

                            <div className="d-flex justify-content-end align-items-end">
                                <div>
                                    <Button
                                        type="button"
                                        icon={<Check size={16} />}
                                        severity="success"
                                        iconPos="right"
                                        label="Proceed"
                                        onClick={onSubmit}
                                        loading={isSubmitting}
                                        disabled={isSubmitting}
                                    />
                                </div>
                            </div>
                        </div>
                    </AppCard.Body>
                </AppCard>
            </Dialog>
        );
    }
}

export default WithdrawConfirmDialogue;
